<template>
  <div class="d-flex flex-row align-center">
    <!-- weekday -->
    <div class="caption align-self-start pb-1 mr-0 text-right" style="width: 80px">{{ formatDate(date, 'de-CH', { weekday: 'long' }) }}</div>

    <!-- go to previous day -->
    <v-btn icon @click="date = -1" :color="isToday(date) ? 'white' : color">
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>

    <!-- day with integrated date picker -->
    <v-menu
      left
      hide-details
      v-model="datePickerMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
      max-width="290"
      z-index="999"
    >
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" style="width: 40px; text-align: right" :class="[isToday(date) ? 'white--text' : ''] + ' text-h4'">
          {{ formatDate(date, 'de-CH', { day: 'numeric' }) }}
        </div>
        <v-icon x-small style="transform: translate(50px, -14px)" :color="isToday(date) ? 'white' : color">mdi-calendar</v-icon>
      </template>
      <v-date-picker v-model="datePicker" first-day-of-week="1" @change="datePickerMenu = false"></v-date-picker>
    </v-menu>

    <!-- go to next day -->
    <v-btn class="ml-2" @click="date = 1" icon :color="isToday(date) ? 'white' : color">
      <v-icon> mdi-chevron-right</v-icon>
    </v-btn>

    <!-- month and year -->
    <div style="width: 100px" class="text-caption align-self-end pb-1 ml-0">{{ formatDate(date, 'de-CH', { year: 'numeric', month: 'long' }) }}</div>

    <!-- Today button -->
    <v-btn outlined rounded color="white" class="ml-1" :disabled="isToday(date)" small text @click.prevent="gotoToday">{{ $t('today') }}</v-btn>
  </div>
</template>

<script>
import dateUtils from '@/common/dateUtils';
export default {
  props: {
    color: {
      type: String,
    },
  },
  data() {
    return {
      //picker: this.date.toISOString().substr(0, 10), //new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      datePickerMenu: false,
    };
  },
  computed: {
    date: {
      get: function () {
        return this.$store.state.vbzWorksheet.contextDate;
      },
      set: function (offset) {
        let date = new Date(this.date);
        date.setDate(date.getDate() + offset);
        console.debug(`setContextDate with offset ${offset} ${date.toISOString()}`);
        this.$store.commit('vbzWorksheet/setContextDate', date);
      },
    },
    datePicker: {
      get: function () {
        return this.date.toISOString().substr(0, 10);
      },
      set: function (dateIsoString) {
        let date = new Date(Date.parse(dateIsoString));
        this.$store.commit('vbzWorksheet/setContextDate', date);
      },
    },
    formattedDate() {
      return this.date ? dateUtils.formatAsLocaleShortDate(this.date) : '';
    },
  },

  methods: {
    formatDate: (date, locale, config) => {
      if (date && typeof date.getMonth === 'function') {
        return date.toLocaleDateString(locale, config);
      }
      return new Date(date).toLocaleDateString(locale, config);
    },
    gotoToday() {
      let today = new Date();
      this.$store.commit('vbzWorksheet/setContextDate', today);
    },
    isToday(d) {
      let date = new Date(d);
      let today = new Date();

      date.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
    },
  },
};
</script>
